import axios from 'axios'
import {store} from "../storage";

const url = 'http://10.1.110.121:8000'
axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('t');
const state = {
  endpoints: {
    dimensiones: url + '/dimensiones/',
    problemas: url + '/problemas/',
    linea: url + '/linea/'
  },
  dimensiones: [],
  problemas: [],
  lineas: []
}

const mutations = {
  /**DIMENSIONES**/
  async listarDimensiones(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.dimensiones, {
      headers: {

      },
    }).then((response) => {
      state.dimensiones = response.data
    }).catch(error => {
      state.dimensiones = []
    })
  },
  saveDimension(state, valor) {
    axios.post(state.endpoints.dimensiones, {
      titulo: valor,
    }).then(function (response) {
      console.log('saved successfully')
    })
    state.dimensiones.push(valor);
  },
  /**PROBLEMAS**/
  async listarProblemas(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.problemas).then((response) => {
      state.problemas = response.data
    }).catch(error => {
      state.problemas = []
    })
  },
  saveProblema(state, valor) {
    axios.post(state.endpoints.problemas, {
      tema: valor.tema,
      pregunta: valor.pregunta,
      dimension: valor.dimension,
      owner: valor.owner,
      publicado: valor.publicado
    }).then(function (response) {
      console.log('saved successfully')
    })
    var dimension = (state.dimensiones.find(dimension => dimension.id === valor.dimension))
    valor.dimension = dimension
    state.problemas.push(valor);
  },
  eliminarProblema(state, id) {
    axios.delete(state.endpoints.problemas + id)
      .then(function (response) {
        state.problemas.splice(state.problemas.indexOf(id), 1);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  editarProblema(state, valor) {
    axios.put(state.endpoints.problemas + valor.id + '/', {
      id: valor.id,
      tema: valor.tema,
      pregunta: valor.pregunta,
      dimension: valor.dimension,
      owner: valor.owner,
      publicado: valor.publicado
    }).then(function (response) {
      console.log('saved successfully')
    })
    var dimension = (state.dimensiones.find(dimension => dimension.id === valor.dimension))
    valor.dimension = dimension
    var index = state.problemas.findIndex(problem => problem.id === valor.id)
    state.problemas[index] = valor
  },
  /**LINEA**/
  async listarLineas(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.linea).then((response) => {
      state.lineas = response.data
    }).catch(error => {
      state.lineas = []
    })
  },
}

const actions = {
  /**DIMENSIONES**/
  getDimensiones({commit}, jwt) {
    commit('listarDimensiones')
  },
  addDimension({commit}, valor) {
    commit('saveDimension', valor)
  },
  /**PROBLEMAS**/
  getProblemas({commit}, jwt) {
    commit('listarProblemas')
  },
  addProblema({commit}, valor) {
    commit('saveProblema', valor)
  },
  deleteProblema({commit}, id) {
    commit('eliminarProblema', id)
  },
  updateProblema({commit}, valor) {
    commit('editarProblema', valor)
  },
  /**LINEAS**/
  getLineas({commit}, jwt) {
    commit('listarLineas')
  },
}


const getters = {
  dimensiones: (state) => {
    return state.dimensiones
  },
  problemas: (state) => {
    /*store.dispatch('getDimensiones')
    state.problemas.forEach((problema) => {
      problema.dimension = (state.dimensiones.find(dimension => dimension.id === problema.dimension))
    })*/
    return state.problemas
  },
  lineas: (state) => {
    return state.lineas
  },
  countProblemas: (state) => state.problemas.length
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/bancoProblemas.js